import config from '@/config';
import { LogicContext } from '@/logic/main/types';
import models from '@/model';
import { checkIfFetchStrikeGold } from '@/utils/strikeGold/checkIfFetchStrikeGold';

export const fetchStrikeGold = (context: LogicContext) => async () => {
  const { controllersData } = context;
  if (!checkIfFetchStrikeGold(controllersData?.categories))
    return { ...context.strikeGoldData };

  const { status, data } = await models.fetchStrikeGoldData({
    market_country:
      config.features.strikeGoldWidget?.defaultMarket ?? config.viewer_country,
  });

  return {
    status,
    strikeGold: data,
  };
};
